import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
import { Main } from 'components/Main';
const AccountRaw = React.lazy(() => import(/* webpackChunkName: "ClientAccount" */ './Account'));
export const ClientAccount = () => (React.createElement(Page, { title: "Account", description: "Account or profile of client." },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AccountRaw, null)))));
